<script setup>
const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div
    class="flex items-center hamburger cursor-pointer top-0 right-[20px] md:right-[30px] inline-block z-3"
    :class="{ 'is--active': active }"
  > <span class="hidden md:block pr-xs">
      {{ active ? 'Menu sluiten' : 'Menu' }}
    </span>
    <button
      id="navigation-button"
      class="hamburger text-center w-30px h-30px relative top-[2px] lg:top-0"
      aria-label="Open/Sluit menu"
    >
      <span
        class="hamburger__lines transition-all relative inline-block h-[28px] w-[28px] pointer-events-none top-[3px]"
      >
        <span
          class="line-top transition-top absolute top-[4px] left-0 h-[2px] w-[28px] mb-[6px] bg-white pointer-events-none"
        ></span>
        <span
          class="line-center transition-all absolute top-[12px] left-0 h-[2px] w-[28px] mb-[6px] bg-white pointer-events-none"
        ></span>
        <span
          class="line-bottom transition-top absolute top-[20px] left-0 h-[2px] w-[28px] mb-1 bg-white pointer-events-none"
        ></span>
      </span>
    </button>
  </div>
</template>

<style>
.hamburger.is--active {
  @apply border-l-0;
}

.hamburger.is--active .hamburger__lines {
  @apply delay-200 -rotate-45 origin-center;
}

.hamburger.is--active .line-top {
  @apply top-[12px];
}

.hamburger.is--active .line-center {
  @apply delay-150 -rotate-90 origin-center;
}

.hamburger.is--active .line-bottom {
  @apply top-[12px];
}
</style>
